import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { MatIcon, MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class IconService {
  constructor(
    private http: HttpClient,
    private injector: Injector,
    private matIconRegistry: MatIconRegistry,
    private domSanitzer: DomSanitizer
  ) {
    const matIconElement = createCustomElement(MatIcon, { injector: this.injector });
    customElements.define('mat-icon', matIconElement);
  }

  loadIcons() {
    return this.http.get('assets/icons/icons.json').pipe(
      tap(items => {
        const icons: [] = (items as any)['icons-array'];

        icons.forEach(icon => {
          const url = this.domSanitzer.bypassSecurityTrustResourceUrl(`assets/icons/${icon}`);
          this.matIconRegistry.addSvgIcon(icon, url);
        });
      })
    );
  }
}
